import { useField } from 'formik';
import { useCallback } from 'react';
import Radio, { RadioProps } from './radio.component';

type BaseProps = Omit<Omit<RadioProps, 'onChange'>, 'value'>;

interface Props extends BaseProps {
  name: string;
}

const FormikRadio: React.FC<Props> = ({ name, ...props }) => {
  const [field, meta, helpers] = useField(name);
  const handleChange: RadioProps['onChange'] = useCallback(
    (e) => {
      helpers.setValue(e.target.value);
    },
    [helpers]
  );
  return (
    <Radio
      {...props}
      error={Boolean(meta.touched && meta.error)}
      helperText={meta.touched ? meta.error : undefined}
      onChange={handleChange}
      value={field.value}
    />
  );
};

export default FormikRadio;
